import { render, staticRenderFns } from "./promotionSuccess.vue?vue&type=template&id=d106e2ce&scoped=true"
import script from "./promotionSuccess.vue?vue&type=script&lang=js"
export * from "./promotionSuccess.vue?vue&type=script&lang=js"
import style0 from "./promotionSuccess.vue?vue&type=style&index=0&id=d106e2ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d106e2ce",
  null
  
)

export default component.exports